<meta name="viewport" content="width=device-width, initial-scale=1.0">
<div class="maintenance padding-1p5em  vertical-column-start-content-centered-items position-abs">
  <div class="vertical-container width-8em height-4em overflow-hidden ">
    <app-orca-logo [divStyling]="'logo-maintenance'" [logoType]="'black'" (click)="back()"/>
  </div>
  <div class="maintenance-container stretched-aligned-centered-column-container ">
    <div class="maintenance-image max-width-40em width-100pcnt">  
      <img src="../../assets/svg/common/maintenance.svg">
    </div>
    <div class="maintenance-title-subtitle font-1p32813em max-width-28em">
      <div class="bold600">{{title}}</div>
      <span class="font-0p9375em line-height-140 ">{{subTitle}}</span>
    </div>
  </div>
</div>